import { atom } from "recoil";
import { ObjectiveKey, ObjectivePresetId } from "shared/domain/objectivePresets";

// Studyの進捗ステータス
export interface StudyStatus {
  name: string;
  running: number;
  complete: number;
  pruned: number;
  failed: number;
}

// 過去最適化studies 一覧
export const studyHistoryState = atom<string[]>({
  key: "studiesHistoryState",
  default: [],
});

// 過去最適化studies ロード
export const studyHistoryLoadingState = atom<boolean>({
  key: "studyHistoryLoadingState",
  default: false,
});

// ユーザがドロップダウンで選択した最適化study
export const selectedStudyState = atom<StudyStatus | null>({
  key: "selectedStudyState",
  default: null,
});

export interface Study {
  status_code: number;
  name: string;
  presetId: ObjectivePresetId;
  objectives: ObjectiveKey[];
  objective_list: {
    objective_list_1: (number | null)[];
    objective_list_2?: (number | null)[];
  };
  cfd_id_list: {
    cfd_id_list_1: string[];
    cfd_id_list_2?: string[];
  };
  // 多目的でも trial 単位で 1 リストのみ（API 契約: error_code_list_2 は存在しない）
  error_code_list?: {
    error_code_list_1: (string | null)[];
  };
  // 多目的最適化時のみ存在（累積ハイパーボリューム）
  hypervolume_list?: (number | null)[];
}

// 結果を描画するstudy
export const displayStudyState = atom<Study | null>({
  key: "displayStudyState",
  default: null,
});

// 結果を描画するstudy ロード
export const displayStudyLoadingState = atom<boolean>({
  key: "displayStudyLoadingState",
  default: false,
});
